<div class="container-fluid">
   <form #f="ngForm" (ngSubmit)="updateReceipe()">
      <div class="row">
         <div class="col-lg-12">
            <div class="iq-card">
               <div class="iq-card-header d-flex justify-content-between">
                  <div class="iq-header-title">
                     <h4 class="card-title">Update Recipe Information</h4>
                  </div>
               </div>

               <div class="iq-card-body">
                  <div class="new-user-info">
                     <div class="row">


                        <!-- Diet Tags -->
                        <div class="form-group col-md-12">
                           <div class="form-group col-md-12">
                              <label for="fname">Diet Tags<span class="color">*</span>:</label>
                           </div>
                           <div class="col-2 floatLeft" *ngFor="let dietTag of diets">
                              <label class="checkbox-inline">
                                 <input type="checkbox" [checked]="checkTagSelected(dietTag, 1)"
                                    (change)="selectedTags($event, dietTag, 1)" />
                                 <span style="padding-left:6px;">{{ dietTag }}</span>
                              </label>
                           </div>
                        </div>

                        <!-- Allergy Tags -->
                        <div class="form-group col-md-12">
                           <div class="form-group col-md-12">
                              <label for="fname">Allergy Tags<span class="color">*</span>:</label>
                           </div>
                           <div class="col-2 floatLeft" *ngFor="let allergyTag of allergies">
                              <label class="checkbox-inline">
                                 <input type="checkbox" [checked]="checkTagSelected(allergyTag, 2)"
                                    (change)="selectedTags($event, allergyTag, 2)" />
                                 <span style="padding-left:6px;">{{ allergyTag }}</span>
                              </label>
                           </div>
                        </div>


                        <!-- Recipe Name -->
                        <div class="form-group col-md-6">
                           <label for="fname">Recipe Name<span class="color">*</span>:</label>
                           <input type="text" pInputText [(ngModel)]="recipe.recipeName"
                              [ngModelOptions]="{standalone: true}" required class="form-control" id="fname"
                              placeholder="Recipe Name">
                        </div>

                        <!-- Recipe Type -->
                        <div class="form-group col-md-6">
                           <label for="fname">Recipe Type<span class="color">*</span>:</label>
                           <select class="form-control" [(ngModel)]="recipe.recipeType"
                              [ngModelOptions]="{standalone: true}">
                              <option value="">Choose Type</option>
                              <option value="breakfast" [selected]="recipe.recipeType == 'breakfast'">Breakfast
                              </option>
                              <option value="snacks" [selected]="recipe.recipeType == 'snacks'">Snacks</option>
                              <option value="lunch" [selected]="recipe.recipeType == 'lunch'">Lunch</option>
                              <option value="dinner" [selected]="recipe.recipeType == 'dinner'">Dinner</option>
                              <option value="main_dishes" [selected]="recipe.recipeType == 'main_dishes'">Main Dishes
                              </option>
                              <option value="soup_salad" [selected]="recipe.recipeType == 'soup_salad'">Soup & Salad
                              </option>
                              <option value="smoothie" [selected]="recipe.recipeType == 'smoothie'">Smoothie</option>
                           </select>
                        </div>

                        <!-- Evaporation -->
                        <div class="form-group col-md-6">
                           <label for="fname"><strong>Evaporation</strong><span class="color">*</span>:</label>
                           <input type="text" pInputText [(ngModel)]="recipe.evaporate"
                              [ngModelOptions]="{standalone: true}" required class="form-control" id="fname"
                              placeholder="Evaporation">
                        </div>

                        <!-- Ingredients Header -->
                        <div class="form-group col-md-12">
                           <label for="lname">Ingredients:</label>
                        </div>

                        <!-- Ingredients Table -->
                        <div class="form-group col-md-12">
                           <table class="table">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>Ingredients</th>
                                    <th>Measure</th>
                                    <th>Qty</th>
                                    <th>Cals</th>
                                    <th>Protien</th>
                                    <th>Carbs</th>
                                    <th>Fat</th>
                                    <th>Action</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr *ngFor="let row of rows;let i = index">
                                    <td>{{i+1}}</td>
                                    <td>
                                       <input type="text" [(ngModel)]="row.ingredientName"
                                          (keyup)="searchIngredent($event,i)" [ngModelOptions]="{standalone: true}"
                                          placeholder="Ingredients" class="form-control" />
                                       <input type="hidden" [(ngModel)]="row.ingredientId"
                                          [ngModelOptions]="{standalone: true}" />
                                       <div *ngIf="rows[i].isSearchBoxShow" class="col-md-2 searchBox">
                                          <span *ngIf="showPleaseText"> Please wait... </span>
                                          <ul>
                                             <li *ngFor="let Ingre of rows[i]['searchIngredents'];let j = index">
                                                <a (click)="selectedIngredent(Ingre.ingredientTitle,Ingre.id,i,Ingre)"
                                                   href="javascript:void(0)">
                                                   {{Ingre.ingredientTitle}}
                                                </a>
                                             </li>
                                          </ul>
                                       </div>
                                    </td>
                                    <td *ngIf="row.checkUpdate == 1">
                                       <select [(ngModel)]="row.measureUnit" class="form-control up"
                                          (change)="addUnit($event,i,1)" [ngModelOptions]="{standalone: true}">
                                          <option value="{{row.measureUnit}}" selected>
                                             {{row.measureUnit}} {{row.measurementUnitValue}}
                                          </option>
                                       </select>
                                    </td>
                                    <td *ngIf="row.checkUpdate == 2">
                                       <select [(ngModel)]="row.measure" class="form-control here"
                                          (change)="addUnit($event,i,1)" [ngModelOptions]="{standalone: true}">
                                          <option value="">Choose Measure</option>
                                          <option *ngFor="let measureType of row.measurement" [value]="measureType">
                                             {{ measureType}} ({{row.measureunit[measureType]}} {{row.measureUnit}})
                                          </option>
                                       </select>
                                    </td>
                                    <td class="fixedWidth">
                                       <input pinputtext pKeyFilter="int" (keyup)="addUnit($event,i,2)"
                                          [(ngModel)]="row.qty" [ngModelOptions]="{standalone: true}"
                                          class="form-control serveInput" placeholder="Qty">
                                    </td>
                                    <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                                          [(ngModel)]="row.cals" [ngModelOptions]="{standalone: true}"
                                          placeholder="Cals"></td>
                                    <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                                          [(ngModel)]="row.protien" [ngModelOptions]="{standalone: true}"
                                          placeholder="Protien"></td>
                                    <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                                          [(ngModel)]="row.carbs" [ngModelOptions]="{standalone: true}"
                                          placeholder="Carbs"></td>
                                    <td class="fixedWidth"><input pinputtext pKeyFilter="int" class="form-control"
                                          [(ngModel)]="row.fat" [ngModelOptions]="{standalone: true}" placeholder="Fat">
                                    </td>
                                    <td><button type="button" class="btn btn-danger" (click)="deleteRow(row)">Remove</button></td>
                                 </tr>
                                 <tr>
                                    <td>Total</td>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>{{recipe.totalCals}}</td>
                                    <td>{{recipe.totalProtien}}</td>
                                    <td>{{recipe.totalCarbs}}</td>
                                    <td>{{recipe.totalFats}}</td>
                                 </tr>
                              </tbody>
                           </table>
                           <button type="button" class="btn btn-success" (click)="addRow()">Add Row</button>
                        </div>

                        <!-- Short Description -->
                        <div class="form-group col-md-12">
                           <label for="lname">Short Description:</label>
                           <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="recipe.shortDescription"
                              [ngModelOptions]="{standalone: true}"></angular-editor>
                        </div>

                        <!-- Recipe Image -->
                        <div class="form-group col-md-6">
                           <div class="form-group col-md-12">
                              <label for="fname">Recipe Image:</label>
                              <input type="file" pInputText (change)="this.onFilechange($event)"
                                 [(ngModel)]="recipe.recipeImageUpload" [ngModelOptions]="{standalone: true}"
                                 pKeyFilter="alpha">
                              <img *ngIf="recipe.recipeImageUpload" 
     [src]="'data:image/jpeg;base64,' + recipe.recipeImageUpload" 
     style="width: 100px; height: auto;" 
     class="rounded shadow-sm border" 
     alt="Recipe Image" />

                           </div>
                        </div>

                        <!-- Reference Link -->
                        <div class="form-group col-md-6">
                           <div class="form-group col-md-12">
                              <label for="fname">Reference Link:</label>
                              <input type="text" pInputText [(ngModel)]="recipe.referenceLink"
                                 [ngModelOptions]="{standalone: true}" class="form-control"
                                 placeholder="Reference Link">
                           </div>
                        </div>

                        <!-- Preparation Steps -->
                        <div class="form-group col-md-12">
                           <table class="table">
                              <thead>
                                 <tr>
                                    <th>#</th>
                                    <th>Preparation Step</th>
                                    <th>Description</th>
                                 </tr>
                              </thead>
                              <tbody>
                                 <tr *ngFor="let row of rowStep;let i = index">
                                    <td>Step {{i+1}}</td>
                                    <td class="descriptionClass">
                                       <input class="form-control" [(ngModel)]="row.description"
                                          [ngModelOptions]="{standalone: true}" placeholder="Description">
                                    </td>
                                    <td><button type="button" class="btn btn-danger"
                                          (click)="deleteRowStep(i)">Remove</button></td>
                                 </tr>
                              </tbody>
                           </table>
                           <button type="button" class="btn btn-success" (click)="addStepRow()">Add Row</button>
                        </div>

                        <!-- Note -->
                        <div class="form-group col-md-12">
                           <label for="fname">Note:</label>
                           <textarea [(ngModel)]="recipe.note" [ngModelOptions]="{standalone: true}"
                              class="form-control" placeholder="Note"></textarea>
                        </div>

                        <!-- Submit -->
                        <button type="submit" class="btn btn-primary">Update Receipe</button>

                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </form>
</div>
